import { render, staticRenderFns } from "./ReportGenerationConfirmation.vue?vue&type=template&id=2f536b0b&scoped=true&"
import script from "./ReportGenerationConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReportGenerationConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f536b0b",
  null
  
)

export default component.exports